import { create } from 'zustand'
import orderService from '../services/orderService'

const useOrderStore = create((set) => ({
    orders: [],
    loading: false,
    error: null,

    fetchOrders: async () => {
        set({ loading: true, error: null })
        try {
            const { success, data, message } = await orderService.getOrders()
            if (success) {
                set({ orders: data, loading: false })
            } else {
                set({ error: message, loading: false })
            }
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    fetchOrder: async (orderId) => {
        set({ loading: true, error: null })
        try {
            const { success, data, message } = await orderService.getOrder(orderId)
            if (success) {
                set((state) => ({ order: data, loading: false }))
            } else {
                set({ error: message, loading: false })
            }
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    createOrder: async (orderData) => {
        set({ loading: true, error: null })
        const { success, message } = await orderService.createOrder(orderData)
        if (success) {
            set((state) => ({ orders: [...state.orders, orderData], loading: false }))
            return { success: true }
        } else {
            set({ error: message, loading: false })
            console.error('Create Order Error:', message)
            return { success: false, message }
        }
    },

    updateOrder: async (orderId, orderData) => {
        set({ loading: true, error: null })
        const { success, message } = await orderService.updateOrder(orderId, orderData)
        if (success) {
            set((state) => ({ order: data, loading: false }))
            return { success: true }
        } else {
            set({ error: message, loading: false })
            console.error('Update Order Error:', message)
            return { success: false, message }
        }
    },

    deleteOrder: async (orderId) => {
        set({ loading: true, error: null })
        try {
            const { success, message } = await orderService.deleteOrder(orderId)
            if (success) {
                set((state) => ({
                    orders: state.orders.filter((order) => order.id !== orderId),
                    loading: false,
                }))
            } else {
                set({ error: message, loading: false })
            }
        } catch (error) {
            set({ error: error.message, loading: false })
        }
    },

    clearState: () => {
        set({ orders: [], loading: false, error: null })
    },
}))

export default useOrderStore
